module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Drone.9aa07f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Drone.jpg
// module id = xX/0
// module chunks = 0